import { appDownloadLink } from '@helpers/constants';
import DownloadAppQrCode from '@molecules/DownloadAppQrCode';
import { Image, Text } from '@ui/atoms';
import Button from '@ui/atoms/design-system/Button';
import { useWindowSize } from '@uidotdev/usehooks';
import { useState } from 'react';
import texts from "./en.json";

const DownloadAppTicker = ({ positionClassName, isLogged = false }) => {
    const { width } = useWindowSize();
    const [showAppDownloadPrompt, setShowAppDownloadPrompt] = useState(false);

    return (
        <>
            <div
                className={`w-full bg-secondary-50 py-2 text-center flex justify-center items-center gap-1 rounded-t-2xl border  border-secondary-200 ${positionClassName}`}
            >
                <div className="xl:left-auto relative w-[55px] -top-[53.5px] block mr-3">
                    <div className={`${!isLogged ? 'animate-slide-up' : ''} left-0 top-0 absolute`}>
                        <Image src={'/images/mobile-app.png'} alt="app-store" />
                    </div>
                </div>

                <Text
                    content={texts?.YourJourneyToFixedInvestmentsStartsHere}
                    className="p3-regular text-primary-500 md:block hidden ml-4"
                />
                <span className="text-gray-200 md:block hidden ml-3">|</span>

                <Button
                    buttonType="textunderline"
                    buttonText={texts?.DownloadJiraafApp}
                    prefixComponent={
                        <Image
                            src={'/images/download-arrow-down-tray.svg'}
                            className="w-4 h-4"
                        />
                    }
                    className="relative md:left-0 py-2 px-3 z-20"
                    onClick={() => {
                        if (width < 1024) {
                            window.open(appDownloadLink, '_blank');
                        } else {
                            setShowAppDownloadPrompt(true);
                        }
                    }}
                />
            </div>

            {showAppDownloadPrompt && (
                <DownloadAppQrCode
                    show={showAppDownloadPrompt}
                    onClose={() => setShowAppDownloadPrompt(false)}
                />
            )}
        </>
    );
};

export default DownloadAppTicker;
